/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rows: NonNullable<unknown> }} Gdpr_Audit_Verify_OkInputs */

const cs_gdpr_audit_verify_ok = /** @type {(inputs: Gdpr_Audit_Verify_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Řetězec v pořádku (${i?.rows} záznamů).`)
};

const en_gdpr_audit_verify_ok = /** @type {(inputs: Gdpr_Audit_Verify_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chain intact (${i?.rows} entries).`)
};

/**
* | output |
* | --- |
* | "Chain intact ({rows} entries)." |
*
* @param {Gdpr_Audit_Verify_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_audit_verify_ok = /** @type {((inputs: Gdpr_Audit_Verify_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Audit_Verify_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_audit_verify_ok(inputs)
	return cs_gdpr_audit_verify_ok(inputs)
});